import { Plot } from "@/components/Plotting/models/Plot";


export class QueuePlotsArgs {

    // Flattened plots
    constructor(public readonly plots: Array<Plot>,
        public readonly parentExecutionId?: string,
        public name?: string,
    ) {
        if (plots == null) throw Error("plots are required");
    }

}